import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './banner.css';
import cn from "classnames";
import Audio from '../../../lib/audio';
import axios from 'axios';


const Banner = ({ images, className, style, videoRef, history }) => {
    const coverRef = React.createRef();;
    const handleVideoClick = () => {
        if (!videoRef) return;
        if (videoRef.current.paused) {
            if (videoRef.current.innerHTML.trim() == "") {
                videoRef.current.innerHTML = '<source src="https://oss.pkcode.cn/scratch/video/%E5%B0%8F%E5%A5%A5AI%E7%BC%96%E7%A8%8B%E5%B9%B3%E5%8F%B0%E7%AE%80%E4%BB%8B.mp4" type="video/mp4"/>';
            }
            coverRef.current.hidden = true;
            Audio.stop();
            videoRef.current.play();
        } else {
            coverRef.current.hidden = false;
            videoRef.current.pause();
        }
    }
    const challenge = () => {
        // window.open('https://dev.zhiaotech.com:8005');
        window.open(`${window.config.pkcodeUrl}/sign/auto-sign?api_token=${localStorage.getItem('api-token')}`)
        // const params = {
        //     'api_token': localStorage.getItem('api-token')
        // }

        // let temp_form = document.createElement("form");
        // temp_form.action = `${window.config.pkcodeUrl}/sign/auto-sign`;
        // //如需打开新窗口，form的target属性要设置为'_blank'
        // temp_form.target = "_blank";
        // temp_form.method = "post";
        // temp_form.style.display = "none";
        // //添加参数
        // for (var item in params) {
        //     var opt = document.createElement("input");
        //     opt.name = item;
        //     opt.value = params[item];
        //     temp_form.appendChild(opt);
        // }

        // document.body.appendChild(temp_form);
        // //提交数据
        // temp_form.submit();

        // let formData = new FormData()
        // formData.append('apiToken', localStorage.getItem('api-token'))
        // formData.append('pkcodeUrl', 'https://dev.zhiaotech.com:8005')
        // const xhr = new XMLHttpRequest;
        // xhr.open('post', 'https://dev.zhiaotech.com:8005/api/sign/auto-sign')
        // xhr.send(formData)
        // xhr.onreadystatechange = function () {
        //     console.log(xhr.readyState)
        //     if (xhr.readyState == 4 && xhr.status == 200) {
        //         console.log(xhr.responseText)
        //         document.write(xhr.responseText)
        //         document.close()
        //     }
        // }
    }

    // 新版教学中心
    const newTeach = () => {
        window.open(`${window.config.baseURL}/teacher/publicize`,'_blank')
    }

    return (
        <div className={cn(styles.banner, className)} style={Object.assign({}, style, { position: "relative" })} >
            <div className={styles.antRow}>
                <div className={styles.antCol24}>
                    <div style={{ float: "right", height: '48px' }}>
                        {/* <LoginEntry/> */}
                    </div>
                </div>
            </div>
            <div className={styles.antRow}>
                <div className={cn(styles.antCol, styles.antCol10)}>
                    <div style={{ paddingTop: "40px", position: "relative", height: "100%" }}>
                        <img style={{ height: "78px" }} src={require("./banner_logo.png")} />
                        <div style={{ color: "#fff", fontSize: "16px", paddingRight: "50px", marginTop: "40px" }}
                            dangerouslySetInnerHTML={{ __html: window.L('teach.banner.desc') }}
                        />

                        <div className={styles.btnBox}>
                            <span className={styles.learn} onClick={() => history.push('./courses/studying')}>开始学习</span>
                            <span className={styles.create} onClick={() => history.push('./project/0')}>开始创作</span>
                            <span className={styles.create} onClick={() => challenge()}>编程挑战</span>
                            <span className={styles.create} onClick={() => newTeach()}>教学中心</span>
                        </div>
                    </div>
                </div>
                <div className={cn(styles.antCol, styles.antCol14)}>
                    <div style={{ width: '598px', height: '400px', float: 'right', backgroundImage: 'url(' + require("./video_wrapper.png") + ')', backgroundSize: 'contain' }}>
                        {/*
                    <Carousel autoplay>
                        {
                            images.map((image, index)=>(
                                <div key={index} style={{width:'100%'}}>
                                    <img src={image} style={{height:"280px", marginLeft:'auto', marginRight:'auto'}}/>
                                </div>
                            ))
                        }
                    </Carousel>
                    */}
                        <div
                            ref={coverRef}
                            style={{
                                background: "url(" + require("../../../../../static/play-btn.png") + ") no-repeat center/contain",
                                position: "absolute",
                                width: "325px",
                                height: "182px",
                                marginLeft: "135px",
                                marginTop: "86.5px",
                                backgroundSize: "auto",
                                zIndex: 1
                            }}
                            onClick={handleVideoClick}
                        ></div>
                        {window.config.isInPC ?
                            (<div
                                style={{
                                    position: "absolute",
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    width: "140px",
                                    marginLeft: "500px",
                                    backgroundSize: "auto",
                                }}>
                                <div style={{ marginBottom: '20px' }}>
                                    <a href="https://apps.apple.com/cn/app/scratch%E5%B0%91%E5%84%BF%E7%BC%96%E7%A8%8B/id1517761442" target="_blank">
                                        <img style={{ width: "120px" }} src={require("../../../../../static/download.png")} />
                                        <div style={{ color: "#fff", margin: "auto", width: "100%", textAlign: "center" }}>
                                            iPad版下载
                                        </div>
                                    </a>
                                </div>
                                <div>
                                    <img style={{ width: "120px" }} src={images[0] ? images[0] : require("./public.png")} />
                                    <div style={{ color: "#fff", margin: "auto", width: "100%", textAlign: "center" }}>
                                        微信公众号
                                    </div>
                                </div>
                            </div>
                            ) : null}
                        <video
                            ref={videoRef}
                            poster={`${window.config.staticURL}/img/intro_cover.png`}
                            webkit-playsinline="true"
                            style={{ width: '325px', marginLeft: '135px', marginTop: '86.5px' }}

                            onClick={handleVideoClick}
                        >
                        </video>
                    </div>
                </div>
            </div>
        </div>
    )
}

Banner.propTypes = {
    images: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
    style: PropTypes.object,
    videoRef: PropTypes.object
};


export default withRouter(Banner);
